import React from "react";
import { Button, Card, CardBody, Col, Input, Row, Table } from "reactstrap";
import { CatalogoItem, ItemRow } from "../constants";

type ItemsTableProps = {
  items: ItemRow[];
  unidadOptions: CatalogoItem[];
  impuestoOptions: CatalogoItem[];
  onItemChange: (id: number, field: keyof ItemRow, value: number | string) => void;
  onAddItem: () => void;
  onRemoveItem: (id: number) => void;
};

const renderCatalogLabel = (item: CatalogoItem) =>
  item.descripcion || item.codigo || `#${item.id}`;

const ItemsTable: React.FC<ItemsTableProps> = ({
  items,
  unidadOptions,
  impuestoOptions,
  onItemChange,
  onAddItem,
  onRemoveItem,
}) => (
  <Card className="shadow-sm mb-4">
    <CardBody>
      <Row className="gy-3 mb-3">
        <Col sm={6}>
          <h5 className="mb-1">Items</h5>
          <p className="text-muted mb-0">Los precios incluyen IVA cuando se indique.</p>
        </Col>
        <Col sm={6} className="text-sm-end">
          <Button color="secondary" outline size="sm" onClick={onAddItem}>
            Agregar línea
          </Button>
        </Col>
      </Row>
      <Table responsive className="mb-0">
        <thead>
          <tr>
            <th>Descripción</th>
            <th style={{ width: "120px" }}>Cantidad</th>
            <th style={{ width: "150px" }}>Precio unitario</th>
            <th style={{ width: "140px" }}>Unidad</th>
            <th style={{ width: "150px" }}>Impuesto</th>
            <th style={{ width: "160px" }}>Subtotal</th>
            <th style={{ width: "80px" }} />
          </tr>
        </thead>
        <tbody>
          {items.map((item) => (
            <tr key={item.id}>
              <td>
                <Input
                  type="text"
                  value={item.description}
                  onChange={(event) => onItemChange(item.id, "description", event.target.value)}
                />
              </td>
              <td>
                <Input
                  type="number"
                  min={0}
                  value={item.quantity}
                  onChange={(event) => onItemChange(item.id, "quantity", Number(event.target.value))}
                />
              </td>
              <td>
                <Input
                  type="number"
                  min={0}
                  value={item.unitPrice}
                  onChange={(event) => onItemChange(item.id, "unitPrice", Number(event.target.value))}
                />
              </td>
                      <td>
                        <Input
                          type="select"
                          value={item.unidadMedidaId ?? ""}
                          onChange={(event) =>
                            onItemChange(item.id, "unidadMedidaId", Number(event.target.value))
                          }
                        >
                          <option value="">Unidad</option>
                          {unidadOptions.map((unidad) => (
                            <option key={unidad.id} value={unidad.id}>
                              {renderCatalogLabel(unidad)}
                            </option>
                          ))}
                        </Input>
                      </td>
                      <td>
                        <Input
                          type="select"
                          value={item.impuestoId ?? ""}
                          onChange={(event) =>
                            onItemChange(item.id, "impuestoId", Number(event.target.value))
                          }
                        >
                          <option value="">Impuesto</option>
                          {impuestoOptions.map((imp) => (
                            <option key={imp.id} value={imp.id}>
                              {renderCatalogLabel(imp)}
                            </option>
                          ))}
                        </Input>
                      </td>
                      <td>
                        <strong>
                          {(item.quantity * item.unitPrice).toLocaleString("es-PY", { style: "currency", currency: "PYG" })}
                        </strong>
                      </td>
              <td>
                <Button color="link" size="sm" onClick={() => onRemoveItem(item.id)}>
                  <i className="bi bi-trash text-danger" />
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </CardBody>
  </Card>
);

export default ItemsTable;
